import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UserManagement.css';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterRole, setFilterRole] = useState('all');
  const [filterBlocked, setFilterBlocked] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    fetchUsers();
  }, [filterRole, filterBlocked, searchTerm]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      let url = 'https://mykaddle-api.onrender.com/api/admin/users?';
      if (filterRole !== 'all') url += `role=${filterRole}&`;
      if (filterBlocked !== 'all') url += `isBlocked=${filterBlocked}&`;
      if (searchTerm) url += `search=${searchTerm}&`;
      
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setUsers(response.data.users);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setMessage({ text: 'Error fetching users', type: 'error' });
      setLoading(false);
    }
  };

  const handleBlockToggle = async (userId, currentBlockStatus) => {
    try {
      const token = localStorage.getItem('token');
      const action = currentBlockStatus ? 'unblock' : 'block';
      
      const response = await axios.put(
        `https://mykaddle-api.onrender.com/api/admin/users/${userId}/block`,
        { action },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setMessage({ text: response.data.message, type: 'success' });
      fetchUsers(); // Refresh the list
      
      // Clear message after 3 seconds
      setTimeout(() => setMessage({ text: '', type: '' }), 3000);
    } catch (error) {
      setMessage({ 
        text: error.response?.data?.message || 'Error updating user status', 
        type: 'error' 
      });
    }
  };

  return (
    <div className="user-management">
      <h1>User Management</h1>
      
      {/* Filters */}
      <div className="filters">
        <div className="filter-group">
          <label>Role:</label>
          <select value={filterRole} onChange={(e) => setFilterRole(e.target.value)}>
            <option value="all">All Roles</option>
            <option value="tutee">Tutees</option>
            <option value="tutor">Tutors</option>
            <option value="admin">Admins</option>
          </select>
        </div>
        
        <div className="filter-group">
          <label>Status:</label>
          <select value={filterBlocked} onChange={(e) => setFilterBlocked(e.target.value)}>
            <option value="all">All Users</option>
            <option value="false">Active Only</option>
            <option value="true">Blocked Only</option>
          </select>
        </div>
        
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by name or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      
      {/* Message Display */}
      {message.text && (
        <div className={`admin-message ${message.type}`}>
          {message.text}
        </div>
      )}
      
      {/* Users Table */}
      {loading ? (
        <div className="loading">Loading users...</div>
      ) : (
        <div className="users-table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Joined</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">No users found</td>
                </tr>
              ) : (
                users.map(user => (
                  <tr key={user._id} className={user.isBlocked ? 'blocked-row' : ''}>
                    <td>{user.firstName} {user.lastName}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className={`role-badge role-${user.role}`}>
                        {user.role}
                      </span>
                    </td>
                    <td>
                      <span className={`status-badge ${user.isBlocked ? 'blocked' : 'active'}`}>
                        {user.isBlocked ? 'Blocked' : 'Active'}
                      </span>
                    </td>
                    <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                    <td>
                      <button
                        className={`action-btn ${user.isBlocked ? 'unblock' : 'block'}`}
                        onClick={() => handleBlockToggle(user._id, user.isBlocked)}
                      >
                        {user.isBlocked ? 'Unblock' : 'Block'}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserManagement;